import styled from 'styled-components';

export const ReportForm = styled.div``;

export const ReportFormField = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    margin-top: 0.8rem;
    padding: 1.2rem 1.6rem;

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.energyBlue};
    }

    .component-form-field {
        margin: 0;

        .fake-control {
            min-height: auto;
        }
        .form-control {
            border: 0;
            padding: 0;
        }
        .form-control::placeholder {
            font-style: italic;
        }
        .form-control-label {
            color: #0094f9;
            font-weight: 600;
        }
    }
`;

export const ReportFormOptions = styled.div`
    display: grid;
    gap: 1.2rem;
    grid-template-columns: 1fr;
    margin-top: 0.8rem;

    @media (min-width: 567px) {
        grid-template-columns: 1fr 1fr;
    }
    @media (min-width: 992px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
`;

export const Space = styled.div`
    height: 1.6rem;
    @media (min-width: 992px) {
        height: 3.2rem;
    }
`;

export const Descr = styled.div`
    color: ${({ theme }) => theme.colors.neutralDark};
    display: flex;
    flex-direction: column;
    font-size: 1.4rem;
    gap: 1rem;
    line-height: 1.4;
`;

export const Title = styled.div`
    color: ${({ theme }) => theme.colors.darkBlue};
    font-size: 1.8rem;
    font-weight: 700;

    .smll {
        color: ${({ theme }) => theme.colors.neutralDark};
        display: inline-block;
        font-size: 1.4rem;
        font-weight: 600;
        margin-left: 0.8rem;
    }

    &.form-title {
        @media (min-width: 992px) {
            margin-top: -1.2rem;
        }
    }
`;
export const UnmatchBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;

    label {
        font-family: 'Kanit';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: center;
        color: #252830;
    }
    input {
        background: #56c1d6;
        border-radius: 50%;
        width: 20px;
        height: 20px;
    }
`;
